import { render, staticRenderFns } from "./Winner.vue?vue&type=template&id=1704b684&scoped=true&"
import script from "./Winner.vue?vue&type=script&lang=js&"
export * from "./Winner.vue?vue&type=script&lang=js&"
import style0 from "./Winner.vue?vue&type=style&index=0&id=1704b684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704b684",
  null
  
)

export default component.exports